import "./main.css";
import { jsx as g, jsxs as H, Fragment as ht } from "react/jsx-runtime";
import { Button as qe, CircularProgress as ut, FormHelperText as mt, FormGroup as vt, FormControlLabel as lt, Checkbox as gt, TextField as ye, InputAdornment as he, InputLabel as Tt, IconButton as bt, Radio as Ct, RadioGroup as Et, Select as xt, MenuItem as wt, Modal as St, Box as Ot } from "@mui/material";
import * as F from "react";
import Z, { memo as V, forwardRef as z, Component as Ye, useState as He } from "react";
const At = "https://api.whatsapp.com/send?phone=60162999792", Er = ({
  url: e = At,
  children: r
}) => /* @__PURE__ */ g("a", { className: "clickable-text", href: e, target: "_blank", rel: "noreferrer", children: r }), xr = (e) => {
  const {
    isLoading: r = !1,
    disabled: n = !1,
    className: t = "",
    variant: i = "contained",
    children: o,
    ...s
  } = e;
  return /* @__PURE__ */ H(
    qe,
    {
      className: `button-with-loading flex gap-1.5 ${t}`,
      disabled: n || r,
      variant: i,
      ...s,
      children: [
        o,
        " ",
        !!r && /* @__PURE__ */ g(ut, { size: 14, thickness: 6, className: "!text-pi-gray-4" })
      ]
    }
  );
}, Be = ({
  error: e,
  className: r = ""
}) => e != null && e.message ? /* @__PURE__ */ g(mt, { className: `form-error-message ${r}`, children: e == null ? void 0 : e.message }) : null, wr = V(
  z(
    ({ items: e, className: r = "", error: n, ...t }, i) => /* @__PURE__ */ H("div", { className: `checkbox-group-comp ${r}`, children: [
      /* @__PURE__ */ g(vt, { ...t, ref: i, children: e.map(({ label: o, value: s, key: a }) => /* @__PURE__ */ g(
        lt,
        {
          control: /* @__PURE__ */ g(gt, { className: "self-start -mt-2 mr-[7px]" }),
          label: o,
          value: s
        },
        a
      )) }),
      /* @__PURE__ */ g(Be, { error: n })
    ] })
  )
), Sr = V(
  z(
    ({ InputProps: e, currency: r = "RM", ...n }, t) => /* @__PURE__ */ g(
      ye,
      {
        ref: t,
        type: "tel",
        InputProps: {
          ...e,
          startAdornment: /* @__PURE__ */ g(he, { position: "start", className: "text-SIA", children: /* @__PURE__ */ g("span", { className: "select-none text-pi-gray-1", children: r }) })
        },
        ...n
      }
    )
  )
), Or = z(
  ({
    label: e,
    id: r,
    isError: n = !1,
    className: t = "",
    children: i = null,
    required: o = !1,
    ...s
  }, a) => /* @__PURE__ */ H("div", { className: `form-label mb-4 ${t}`, ...s, ref: a, children: [
    /* @__PURE__ */ H(
      Tt,
      {
        htmlFor: r,
        shrink: !0,
        className: n ? "!text-pi-utility-red" : "",
        children: [
          e,
          " ",
          o && /* @__PURE__ */ g(Pt, {})
        ]
      }
    ),
    i
  ] })
), Pt = () => /* @__PURE__ */ g("span", { className: "text-pi-utility-red", children: "*" });
const Rt = (e) => /* @__PURE__ */ F.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ F.createElement("path", { d: "M18.5462 18.7353C18.9855 18.4005 19.0701 17.773 18.7353 17.3338C18.4005 16.8946 17.773 16.8099 17.3338 17.1447L18.5462 18.7353ZM12 20V21C12.0054 21 12.0109 21 12.0163 20.9999L12 20ZM1 12L0.118844 11.5272C-0.0347896 11.8135 -0.0397388 12.1566 0.105573 12.4472L1 12ZM6.6669 6.8548C7.10584 6.51962 7.18996 5.89207 6.85478 5.45312C6.5196 5.01418 5.89204 4.93007 5.4531 5.26525L6.6669 6.8548ZM9.67209 3.26634C9.13434 3.39222 8.80045 3.93019 8.92632 4.46794C9.05219 5.00569 9.59016 5.33958 10.1279 5.21371L9.67209 3.26634ZM12 4.00003L11.9976 5.00003H12V4.00003ZM23 12L23.8819 12.4714C24.0348 12.1854 24.0395 11.8429 23.8944 11.5528L23 12ZM20.0748 14.5462C19.7193 14.9688 19.7736 15.5996 20.1962 15.9552C20.6187 16.3108 21.2496 16.2565 21.6052 15.8339L20.0748 14.5462ZM14.8516 14.8017C15.2281 14.3977 15.2058 13.7649 14.8017 13.3884C14.3977 13.0119 13.7649 13.0342 13.3884 13.4383L14.8516 14.8017ZM10.5617 10.6116C10.9658 10.2351 10.9881 9.60236 10.6116 9.1983C10.2351 8.79425 9.60233 8.77191 9.19828 9.14841L10.5617 10.6116ZM17.3338 17.1447C15.7941 18.3183 13.9193 18.9685 11.9837 19.0002L12.0163 20.9999C14.3789 20.9613 16.6671 20.1677 18.5462 18.7353L17.3338 17.1447ZM12 19C8.89951 19 6.39552 17.2265 4.60454 15.3161C3.71817 14.3706 3.03543 13.4213 2.57441 12.7075C2.34452 12.3515 2.1714 12.0567 2.05712 11.8535C2.00002 11.752 1.95773 11.6736 1.93051 11.6222C1.9169 11.5964 1.90707 11.5775 1.90104 11.5657C1.89803 11.5599 1.89597 11.5558 1.89486 11.5537C1.89431 11.5526 1.894 11.552 1.89392 11.5518C1.89389 11.5517 1.89391 11.5518 1.894 11.552C1.89404 11.552 1.89415 11.5522 1.89417 11.5523C1.89429 11.5525 1.89443 11.5528 1 12C0.105573 12.4472 0.105741 12.4476 0.105925 12.4479C0.106007 12.4481 0.106206 12.4485 0.10637 12.4488C0.106698 12.4495 0.107087 12.4503 0.107539 12.4512C0.108442 12.4529 0.109592 12.4552 0.11099 12.458C0.113785 12.4635 0.117569 12.4709 0.122338 12.4802C0.131875 12.4988 0.145357 12.5247 0.162753 12.5576C0.19754 12.6233 0.248023 12.7168 0.313971 12.834C0.445792 13.0684 0.63985 13.3985 0.894336 13.7926C1.40207 14.5787 2.15683 15.6294 3.14546 16.684C5.10448 18.7736 8.10049 21 12 21V19ZM1.88116 12.4729C3.05763 10.2804 4.68936 8.36487 6.6669 6.8548L5.4531 5.26525C3.24891 6.94839 1.43015 9.08345 0.118844 11.5272L1.88116 12.4729ZM10.1279 5.21371C10.7408 5.07025 11.3682 4.99854 11.9976 5.00002L12.0023 3.00003C11.2179 2.99818 10.4359 3.08756 9.67209 3.26634L10.1279 5.21371ZM12 5.00003C15.1005 5.00003 17.6045 6.77359 19.3955 8.68397C20.2818 9.62943 20.9646 10.5787 21.4256 11.2926C21.6555 11.6485 21.8286 11.9434 21.9429 12.1465C22 12.248 22.0423 12.3265 22.0695 12.3779C22.0831 12.4036 22.0929 12.4226 22.099 12.4343C22.102 12.4402 22.104 12.4442 22.1051 12.4464C22.1057 12.4475 22.106 12.4481 22.1061 12.4482C22.1061 12.4483 22.1061 12.4483 22.106 12.4481C22.106 12.448 22.1059 12.4478 22.1058 12.4478C22.1057 12.4475 22.1056 12.4472 23 12C23.8944 11.5528 23.8943 11.5525 23.8941 11.5521C23.894 11.5519 23.8938 11.5515 23.8936 11.5512C23.8933 11.5506 23.8929 11.5498 23.8925 11.5489C23.8916 11.5471 23.8904 11.5448 23.889 11.5421C23.8862 11.5366 23.8824 11.5291 23.8777 11.5198C23.8681 11.5013 23.8546 11.4753 23.8372 11.4425C23.8025 11.3767 23.752 11.2833 23.686 11.166C23.5542 10.9317 23.3601 10.6015 23.1057 10.2075C22.5979 9.42134 21.8432 8.37062 20.8545 7.31608C18.8955 5.22646 15.8995 3.00003 12 3.00003V5.00003ZM22.1181 11.5286C21.5439 12.6028 20.8591 13.6142 20.0748 14.5462L21.6052 15.8339C22.479 14.7953 23.2421 13.6684 23.8819 12.4714L22.1181 11.5286ZM13.3884 13.4383C12.8898 13.9734 12.1389 14.1936 11.4303 14.0127L10.9354 15.9505C12.3526 16.3124 13.8544 15.8719 14.8516 14.8017L13.3884 13.4383ZM11.4303 14.0127C10.7217 13.8317 10.1683 13.2784 9.98736 12.5697L8.04955 13.0646C8.41149 14.4819 9.51816 15.5885 10.9354 15.9505L11.4303 14.0127ZM9.98736 12.5697C9.80639 11.8611 10.0266 11.1102 10.5617 10.6116L9.19828 9.14841C8.12813 10.1456 7.68762 11.6474 8.04955 13.0646L9.98736 12.5697Z", fill: "var(--color-pi-principal-blue)" }), /* @__PURE__ */ F.createElement("path", { d: "M1 1L23 23", stroke: "var(--color-pi-principal-blue)", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), Mt = (e) => /* @__PURE__ */ F.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ F.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z", stroke: "var(--color-pi-principal-blue)", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ F.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z", stroke: "var(--color-pi-principal-blue)", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), Ar = V(
  z(
    ({
      className: e = "",
      showPassword: r,
      toggleHideShow: n,
      InputProps: t,
      disabled: i,
      ...o
    }, s) => /* @__PURE__ */ g(
      ye,
      {
        className: `password-text-field ${e}`,
        type: r ? "text" : "password",
        ref: s,
        disabled: i,
        InputProps: {
          ...t,
          endAdornment: /* @__PURE__ */ g(he, { position: "end", children: /* @__PURE__ */ g(
            bt,
            {
              "aria-label": "toggle password visibility",
              onClick: n,
              onMouseDown: n,
              disabled: i,
              edge: "end",
              className: "-mx-2",
              children: r ? /* @__PURE__ */ g(Rt, {}) : /* @__PURE__ */ g(Mt, {})
            }
          ) })
        },
        ...o
      }
    )
  )
), Pr = V(
  z(
    ({
      InputProps: e,
      isLoading: r = !1,
      disabled: n,
      buttonOnClick: t,
      buttonChildren: i,
      ...o
    }, s) => /* @__PURE__ */ g(
      ye,
      {
        ref: s,
        type: "text",
        disabled: n || r,
        InputProps: {
          ...e,
          endAdornment: /* @__PURE__ */ g(he, { position: "end", children: /* @__PURE__ */ g(
            qe,
            {
              onClick: t,
              className: "-mx-2",
              disabled: n || r,
              children: r ? /* @__PURE__ */ g(
                ut,
                {
                  size: 14,
                  thickness: 6,
                  className: "text-pi-gray-4"
                }
              ) : i
            }
          ) })
        },
        ...o
      }
    )
  )
), It = (e) => /* @__PURE__ */ F.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ F.createElement("circle", { cx: 12, cy: 12, r: 11, stroke: "var(--color-pi-gray-3)", strokeWidth: 2 }), /* @__PURE__ */ F.createElement("circle", { cx: 12, cy: 12, r: 8, fill: "var(--color-pi-principal-blue)" })), _t = (e) => /* @__PURE__ */ F.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ F.createElement("circle", { cx: 12, cy: 12, r: 11, stroke: "var(--color-pi-gray-3)", strokeWidth: 2 })), Lt = V(
  z(({ className: e, ...r }, n) => /* @__PURE__ */ g(
    Ct,
    {
      ref: n,
      ...r,
      checkedIcon: /* @__PURE__ */ g(It, {}),
      icon: /* @__PURE__ */ g(_t, {}),
      className: `mr-[11px] ${e}`
    }
  ))
), Rr = V(
  z(
    ({ items: e, className: r = "", error: n, ...t }, i) => /* @__PURE__ */ H("div", { className: `form-group-comp mt-4 ${r}`, children: [
      /* @__PURE__ */ g(Et, { ...t, ref: i, children: e.map(({ label: o, value: s, key: a }, u) => /* @__PURE__ */ g(
        lt,
        {
          value: s,
          control: /* @__PURE__ */ g(Lt, {}),
          label: o,
          className: u !== e.length - 1 ? "mb-[7px]" : ""
        },
        a
      )) }),
      /* @__PURE__ */ g(Be, { error: n })
    ] })
  )
), kt = (e) => /* @__PURE__ */ F.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ F.createElement("path", { d: "M6 9L12 15L18 9", stroke: "var(--color-pi-principal-blue)", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), Mr = V(
  z(
    ({ items: e, error: r, className: n = "", ...t }, i) => /* @__PURE__ */ H("div", { className: `select-box-comp ${n}`, children: [
      /* @__PURE__ */ g(
        xt,
        {
          ...t,
          ref: i,
          error: !!r,
          IconComponent: () => /* @__PURE__ */ g(kt, { className: "custom-icon" }),
          children: e.map(({ label: o, value: s }) => /* @__PURE__ */ g(wt, { value: s, children: o }, `${t.id}-${s}`))
        }
      ),
      /* @__PURE__ */ g(Be, { error: r })
    ] })
  )
), Ir = V(
  z(
    ({ InputProps: e, countryCode: r = "60", ...n }, t) => /* @__PURE__ */ g(
      ye,
      {
        ref: t,
        type: "tel",
        InputProps: {
          ...e,
          startAdornment: /* @__PURE__ */ g(he, { position: "start", className: "text-SIA", children: /* @__PURE__ */ H("strong", { className: "select-none text-pi-gray-1", children: [
            "+",
            r
          ] }) })
        },
        ...n
      }
    )
  )
);
function me(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ne = { exports: {} }, ae = { exports: {} }, M = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ze;
function jt() {
  if (Ze)
    return M;
  Ze = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, t = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, O = e ? Symbol.for("react.memo") : 60115, _ = e ? Symbol.for("react.lazy") : 60116, T = e ? Symbol.for("react.block") : 60121, k = e ? Symbol.for("react.fundamental") : 60117, D = e ? Symbol.for("react.responder") : 60118, B = e ? Symbol.for("react.scope") : 60119;
  function N(l) {
    if (typeof l == "object" && l !== null) {
      var K = l.$$typeof;
      switch (K) {
        case r:
          switch (l = l.type, l) {
            case u:
            case p:
            case t:
            case o:
            case i:
            case y:
              return l;
            default:
              switch (l = l && l.$$typeof, l) {
                case a:
                case h:
                case _:
                case O:
                case s:
                  return l;
                default:
                  return K;
              }
          }
        case n:
          return K;
      }
    }
  }
  function j(l) {
    return N(l) === p;
  }
  return M.AsyncMode = u, M.ConcurrentMode = p, M.ContextConsumer = a, M.ContextProvider = s, M.Element = r, M.ForwardRef = h, M.Fragment = t, M.Lazy = _, M.Memo = O, M.Portal = n, M.Profiler = o, M.StrictMode = i, M.Suspense = y, M.isAsyncMode = function(l) {
    return j(l) || N(l) === u;
  }, M.isConcurrentMode = j, M.isContextConsumer = function(l) {
    return N(l) === a;
  }, M.isContextProvider = function(l) {
    return N(l) === s;
  }, M.isElement = function(l) {
    return typeof l == "object" && l !== null && l.$$typeof === r;
  }, M.isForwardRef = function(l) {
    return N(l) === h;
  }, M.isFragment = function(l) {
    return N(l) === t;
  }, M.isLazy = function(l) {
    return N(l) === _;
  }, M.isMemo = function(l) {
    return N(l) === O;
  }, M.isPortal = function(l) {
    return N(l) === n;
  }, M.isProfiler = function(l) {
    return N(l) === o;
  }, M.isStrictMode = function(l) {
    return N(l) === i;
  }, M.isSuspense = function(l) {
    return N(l) === y;
  }, M.isValidElementType = function(l) {
    return typeof l == "string" || typeof l == "function" || l === t || l === p || l === o || l === i || l === y || l === m || typeof l == "object" && l !== null && (l.$$typeof === _ || l.$$typeof === O || l.$$typeof === s || l.$$typeof === a || l.$$typeof === h || l.$$typeof === k || l.$$typeof === D || l.$$typeof === B || l.$$typeof === T);
  }, M.typeOf = N, M;
}
var I = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ve;
function Nt() {
  return Ve || (Ve = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, t = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, O = e ? Symbol.for("react.memo") : 60115, _ = e ? Symbol.for("react.lazy") : 60116, T = e ? Symbol.for("react.block") : 60121, k = e ? Symbol.for("react.fundamental") : 60117, D = e ? Symbol.for("react.responder") : 60118, B = e ? Symbol.for("react.scope") : 60119;
    function N(f) {
      return typeof f == "string" || typeof f == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      f === t || f === p || f === o || f === i || f === y || f === m || typeof f == "object" && f !== null && (f.$$typeof === _ || f.$$typeof === O || f.$$typeof === s || f.$$typeof === a || f.$$typeof === h || f.$$typeof === k || f.$$typeof === D || f.$$typeof === B || f.$$typeof === T);
    }
    function j(f) {
      if (typeof f == "object" && f !== null) {
        var W = f.$$typeof;
        switch (W) {
          case r:
            var ie = f.type;
            switch (ie) {
              case u:
              case p:
              case t:
              case o:
              case i:
              case y:
                return ie;
              default:
                var ze = ie && ie.$$typeof;
                switch (ze) {
                  case a:
                  case h:
                  case _:
                  case O:
                  case s:
                    return ze;
                  default:
                    return W;
                }
            }
          case n:
            return W;
        }
      }
    }
    var l = u, K = p, ve = a, ge = s, Te = r, be = h, ne = t, Ce = _, Ee = O, J = n, xe = o, U = i, G = y, oe = !1;
    function we(f) {
      return oe || (oe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), c(f) || j(f) === u;
    }
    function c(f) {
      return j(f) === p;
    }
    function d(f) {
      return j(f) === a;
    }
    function w(f) {
      return j(f) === s;
    }
    function E(f) {
      return typeof f == "object" && f !== null && f.$$typeof === r;
    }
    function b(f) {
      return j(f) === h;
    }
    function A(f) {
      return j(f) === t;
    }
    function C(f) {
      return j(f) === _;
    }
    function x(f) {
      return j(f) === O;
    }
    function P(f) {
      return j(f) === n;
    }
    function L(f) {
      return j(f) === o;
    }
    function R(f) {
      return j(f) === i;
    }
    function q(f) {
      return j(f) === y;
    }
    I.AsyncMode = l, I.ConcurrentMode = K, I.ContextConsumer = ve, I.ContextProvider = ge, I.Element = Te, I.ForwardRef = be, I.Fragment = ne, I.Lazy = Ce, I.Memo = Ee, I.Portal = J, I.Profiler = xe, I.StrictMode = U, I.Suspense = G, I.isAsyncMode = we, I.isConcurrentMode = c, I.isContextConsumer = d, I.isContextProvider = w, I.isElement = E, I.isForwardRef = b, I.isFragment = A, I.isLazy = C, I.isMemo = x, I.isPortal = P, I.isProfiler = L, I.isStrictMode = R, I.isSuspense = q, I.isValidElementType = N, I.typeOf = j;
  }()), I;
}
var Ke;
function ft() {
  return Ke || (Ke = 1, process.env.NODE_ENV === "production" ? ae.exports = jt() : ae.exports = Nt()), ae.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Se, Ge;
function $t() {
  if (Ge)
    return Se;
  Ge = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function t(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var u = Object.getOwnPropertyNames(s).map(function(h) {
        return s[h];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(h) {
        p[h] = h;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Se = i() ? Object.assign : function(o, s) {
    for (var a, u = t(o), p, h = 1; h < arguments.length; h++) {
      a = Object(arguments[h]);
      for (var y in a)
        r.call(a, y) && (u[y] = a[y]);
      if (e) {
        p = e(a);
        for (var m = 0; m < p.length; m++)
          n.call(a, p[m]) && (u[p[m]] = a[p[m]]);
      }
    }
    return u;
  }, Se;
}
var Oe, Je;
function Ue() {
  if (Je)
    return Oe;
  Je = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Oe = e, Oe;
}
var Ae, Xe;
function pt() {
  return Xe || (Xe = 1, Ae = Function.call.bind(Object.prototype.hasOwnProperty)), Ae;
}
var Pe, Qe;
function Dt() {
  if (Qe)
    return Pe;
  Qe = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = Ue(), n = {}, t = pt();
    e = function(o) {
      var s = "Warning: " + o;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(o, s, a, u, p) {
    if (process.env.NODE_ENV !== "production") {
      for (var h in o)
        if (t(o, h)) {
          var y;
          try {
            if (typeof o[h] != "function") {
              var m = Error(
                (u || "React class") + ": " + a + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw m.name = "Invariant Violation", m;
            }
            y = o[h](s, h, u, a, null, r);
          } catch (_) {
            y = _;
          }
          if (y && !(y instanceof Error) && e(
            (u || "React class") + ": type specification of " + a + " `" + h + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof y + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), y instanceof Error && !(y.message in n)) {
            n[y.message] = !0;
            var O = p ? p() : "";
            e(
              "Failed " + a + " type: " + y.message + (O ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Pe = i, Pe;
}
var Re, et;
function Ft() {
  if (et)
    return Re;
  et = 1;
  var e = ft(), r = $t(), n = Ue(), t = pt(), i = Dt(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(a) {
    var u = "Warning: " + a;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return Re = function(a, u) {
    var p = typeof Symbol == "function" && Symbol.iterator, h = "@@iterator";
    function y(c) {
      var d = c && (p && c[p] || c[h]);
      if (typeof d == "function")
        return d;
    }
    var m = "<<anonymous>>", O = {
      array: D("array"),
      bigint: D("bigint"),
      bool: D("boolean"),
      func: D("function"),
      number: D("number"),
      object: D("object"),
      string: D("string"),
      symbol: D("symbol"),
      any: B(),
      arrayOf: N,
      element: j(),
      elementType: l(),
      instanceOf: K,
      node: be(),
      objectOf: ge,
      oneOf: ve,
      oneOfType: Te,
      shape: Ce,
      exact: Ee
    };
    function _(c, d) {
      return c === d ? c !== 0 || 1 / c === 1 / d : c !== c && d !== d;
    }
    function T(c, d) {
      this.message = c, this.data = d && typeof d == "object" ? d : {}, this.stack = "";
    }
    T.prototype = Error.prototype;
    function k(c) {
      if (process.env.NODE_ENV !== "production")
        var d = {}, w = 0;
      function E(A, C, x, P, L, R, q) {
        if (P = P || m, R = R || x, q !== n) {
          if (u) {
            var f = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw f.name = "Invariant Violation", f;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var W = P + ":" + x;
            !d[W] && // Avoid spamming the console because they are often not actionable except for lib authors
            w < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + R + "` prop on `" + P + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), d[W] = !0, w++);
          }
        }
        return C[x] == null ? A ? C[x] === null ? new T("The " + L + " `" + R + "` is marked as required " + ("in `" + P + "`, but its value is `null`.")) : new T("The " + L + " `" + R + "` is marked as required in " + ("`" + P + "`, but its value is `undefined`.")) : null : c(C, x, P, L, R);
      }
      var b = E.bind(null, !1);
      return b.isRequired = E.bind(null, !0), b;
    }
    function D(c) {
      function d(w, E, b, A, C, x) {
        var P = w[E], L = U(P);
        if (L !== c) {
          var R = G(P);
          return new T(
            "Invalid " + A + " `" + C + "` of type " + ("`" + R + "` supplied to `" + b + "`, expected ") + ("`" + c + "`."),
            { expectedType: c }
          );
        }
        return null;
      }
      return k(d);
    }
    function B() {
      return k(s);
    }
    function N(c) {
      function d(w, E, b, A, C) {
        if (typeof c != "function")
          return new T("Property `" + C + "` of component `" + b + "` has invalid PropType notation inside arrayOf.");
        var x = w[E];
        if (!Array.isArray(x)) {
          var P = U(x);
          return new T("Invalid " + A + " `" + C + "` of type " + ("`" + P + "` supplied to `" + b + "`, expected an array."));
        }
        for (var L = 0; L < x.length; L++) {
          var R = c(x, L, b, A, C + "[" + L + "]", n);
          if (R instanceof Error)
            return R;
        }
        return null;
      }
      return k(d);
    }
    function j() {
      function c(d, w, E, b, A) {
        var C = d[w];
        if (!a(C)) {
          var x = U(C);
          return new T("Invalid " + b + " `" + A + "` of type " + ("`" + x + "` supplied to `" + E + "`, expected a single ReactElement."));
        }
        return null;
      }
      return k(c);
    }
    function l() {
      function c(d, w, E, b, A) {
        var C = d[w];
        if (!e.isValidElementType(C)) {
          var x = U(C);
          return new T("Invalid " + b + " `" + A + "` of type " + ("`" + x + "` supplied to `" + E + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return k(c);
    }
    function K(c) {
      function d(w, E, b, A, C) {
        if (!(w[E] instanceof c)) {
          var x = c.name || m, P = we(w[E]);
          return new T("Invalid " + A + " `" + C + "` of type " + ("`" + P + "` supplied to `" + b + "`, expected ") + ("instance of `" + x + "`."));
        }
        return null;
      }
      return k(d);
    }
    function ve(c) {
      if (!Array.isArray(c))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), s;
      function d(w, E, b, A, C) {
        for (var x = w[E], P = 0; P < c.length; P++)
          if (_(x, c[P]))
            return null;
        var L = JSON.stringify(c, function(q, f) {
          var W = G(f);
          return W === "symbol" ? String(f) : f;
        });
        return new T("Invalid " + A + " `" + C + "` of value `" + String(x) + "` " + ("supplied to `" + b + "`, expected one of " + L + "."));
      }
      return k(d);
    }
    function ge(c) {
      function d(w, E, b, A, C) {
        if (typeof c != "function")
          return new T("Property `" + C + "` of component `" + b + "` has invalid PropType notation inside objectOf.");
        var x = w[E], P = U(x);
        if (P !== "object")
          return new T("Invalid " + A + " `" + C + "` of type " + ("`" + P + "` supplied to `" + b + "`, expected an object."));
        for (var L in x)
          if (t(x, L)) {
            var R = c(x, L, b, A, C + "." + L, n);
            if (R instanceof Error)
              return R;
          }
        return null;
      }
      return k(d);
    }
    function Te(c) {
      if (!Array.isArray(c))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var d = 0; d < c.length; d++) {
        var w = c[d];
        if (typeof w != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + oe(w) + " at index " + d + "."
          ), s;
      }
      function E(b, A, C, x, P) {
        for (var L = [], R = 0; R < c.length; R++) {
          var q = c[R], f = q(b, A, C, x, P, n);
          if (f == null)
            return null;
          f.data && t(f.data, "expectedType") && L.push(f.data.expectedType);
        }
        var W = L.length > 0 ? ", expected one of type [" + L.join(", ") + "]" : "";
        return new T("Invalid " + x + " `" + P + "` supplied to " + ("`" + C + "`" + W + "."));
      }
      return k(E);
    }
    function be() {
      function c(d, w, E, b, A) {
        return J(d[w]) ? null : new T("Invalid " + b + " `" + A + "` supplied to " + ("`" + E + "`, expected a ReactNode."));
      }
      return k(c);
    }
    function ne(c, d, w, E, b) {
      return new T(
        (c || "React class") + ": " + d + " type `" + w + "." + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + b + "`."
      );
    }
    function Ce(c) {
      function d(w, E, b, A, C) {
        var x = w[E], P = U(x);
        if (P !== "object")
          return new T("Invalid " + A + " `" + C + "` of type `" + P + "` " + ("supplied to `" + b + "`, expected `object`."));
        for (var L in c) {
          var R = c[L];
          if (typeof R != "function")
            return ne(b, A, C, L, G(R));
          var q = R(x, L, b, A, C + "." + L, n);
          if (q)
            return q;
        }
        return null;
      }
      return k(d);
    }
    function Ee(c) {
      function d(w, E, b, A, C) {
        var x = w[E], P = U(x);
        if (P !== "object")
          return new T("Invalid " + A + " `" + C + "` of type `" + P + "` " + ("supplied to `" + b + "`, expected `object`."));
        var L = r({}, w[E], c);
        for (var R in L) {
          var q = c[R];
          if (t(c, R) && typeof q != "function")
            return ne(b, A, C, R, G(q));
          if (!q)
            return new T(
              "Invalid " + A + " `" + C + "` key `" + R + "` supplied to `" + b + "`.\nBad object: " + JSON.stringify(w[E], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(c), null, "  ")
            );
          var f = q(x, R, b, A, C + "." + R, n);
          if (f)
            return f;
        }
        return null;
      }
      return k(d);
    }
    function J(c) {
      switch (typeof c) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !c;
        case "object":
          if (Array.isArray(c))
            return c.every(J);
          if (c === null || a(c))
            return !0;
          var d = y(c);
          if (d) {
            var w = d.call(c), E;
            if (d !== c.entries) {
              for (; !(E = w.next()).done; )
                if (!J(E.value))
                  return !1;
            } else
              for (; !(E = w.next()).done; ) {
                var b = E.value;
                if (b && !J(b[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function xe(c, d) {
      return c === "symbol" ? !0 : d ? d["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && d instanceof Symbol : !1;
    }
    function U(c) {
      var d = typeof c;
      return Array.isArray(c) ? "array" : c instanceof RegExp ? "object" : xe(d, c) ? "symbol" : d;
    }
    function G(c) {
      if (typeof c > "u" || c === null)
        return "" + c;
      var d = U(c);
      if (d === "object") {
        if (c instanceof Date)
          return "date";
        if (c instanceof RegExp)
          return "regexp";
      }
      return d;
    }
    function oe(c) {
      var d = G(c);
      switch (d) {
        case "array":
        case "object":
          return "an " + d;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + d;
        default:
          return d;
      }
    }
    function we(c) {
      return !c.constructor || !c.constructor.name ? m : c.constructor.name;
    }
    return O.checkPropTypes = i, O.resetWarningCache = i.resetWarningCache, O.PropTypes = O, O;
  }, Re;
}
var Me, tt;
function qt() {
  if (tt)
    return Me;
  tt = 1;
  var e = Ue();
  function r() {
  }
  function n() {
  }
  return n.resetWarningCache = r, Me = function() {
    function t(s, a, u, p, h, y) {
      if (y !== e) {
        var m = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw m.name = "Invariant Violation", m;
      }
    }
    t.isRequired = t;
    function i() {
      return t;
    }
    var o = {
      array: t,
      bigint: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: i,
      element: t,
      elementType: t,
      instanceOf: i,
      node: t,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: r
    };
    return o.PropTypes = o, o;
  }, Me;
}
if (process.env.NODE_ENV !== "production") {
  var Yt = ft(), Ht = !0;
  Ne.exports = Ft()(Yt.isElement, Ht);
} else
  Ne.exports = qt()();
var Bt = Ne.exports;
const S = /* @__PURE__ */ me(Bt);
var Ut = typeof Element < "u", Wt = typeof Map == "function", zt = typeof Set == "function", Zt = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function ue(e, r) {
  if (e === r)
    return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    if (e.constructor !== r.constructor)
      return !1;
    var n, t, i;
    if (Array.isArray(e)) {
      if (n = e.length, n != r.length)
        return !1;
      for (t = n; t-- !== 0; )
        if (!ue(e[t], r[t]))
          return !1;
      return !0;
    }
    var o;
    if (Wt && e instanceof Map && r instanceof Map) {
      if (e.size !== r.size)
        return !1;
      for (o = e.entries(); !(t = o.next()).done; )
        if (!r.has(t.value[0]))
          return !1;
      for (o = e.entries(); !(t = o.next()).done; )
        if (!ue(t.value[1], r.get(t.value[0])))
          return !1;
      return !0;
    }
    if (zt && e instanceof Set && r instanceof Set) {
      if (e.size !== r.size)
        return !1;
      for (o = e.entries(); !(t = o.next()).done; )
        if (!r.has(t.value[0]))
          return !1;
      return !0;
    }
    if (Zt && ArrayBuffer.isView(e) && ArrayBuffer.isView(r)) {
      if (n = e.length, n != r.length)
        return !1;
      for (t = n; t-- !== 0; )
        if (e[t] !== r[t])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === r.source && e.flags === r.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof r.valueOf == "function")
      return e.valueOf() === r.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof r.toString == "function")
      return e.toString() === r.toString();
    if (i = Object.keys(e), n = i.length, n !== Object.keys(r).length)
      return !1;
    for (t = n; t-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, i[t]))
        return !1;
    if (Ut && e instanceof Element)
      return !1;
    for (t = n; t-- !== 0; )
      if (!((i[t] === "_owner" || i[t] === "__v" || i[t] === "__o") && e.$$typeof) && !ue(e[i[t]], r[i[t]]))
        return !1;
    return !0;
  }
  return e !== e && r !== r;
}
var Vt = function(r, n) {
  try {
    return ue(r, n);
  } catch (t) {
    if ((t.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw t;
  }
};
const Kt = /* @__PURE__ */ me(Vt);
var Gt = function(e, r, n, t, i, o, s, a) {
  if (process.env.NODE_ENV !== "production" && r === void 0)
    throw new Error("invariant requires an error message argument");
  if (!e) {
    var u;
    if (r === void 0)
      u = new Error(
        "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
      );
    else {
      var p = [n, t, i, o, s, a], h = 0;
      u = new Error(
        r.replace(/%s/g, function() {
          return p[h++];
        })
      ), u.name = "Invariant Violation";
    }
    throw u.framesToPop = 1, u;
  }
}, Jt = Gt;
const rt = /* @__PURE__ */ me(Jt);
var Xt = function(r, n, t, i) {
  var o = t ? t.call(i, r, n) : void 0;
  if (o !== void 0)
    return !!o;
  if (r === n)
    return !0;
  if (typeof r != "object" || !r || typeof n != "object" || !n)
    return !1;
  var s = Object.keys(r), a = Object.keys(n);
  if (s.length !== a.length)
    return !1;
  for (var u = Object.prototype.hasOwnProperty.bind(n), p = 0; p < s.length; p++) {
    var h = s[p];
    if (!u(h))
      return !1;
    var y = r[h], m = n[h];
    if (o = t ? t.call(i, y, m, h) : void 0, o === !1 || o === void 0 && y !== m)
      return !1;
  }
  return !0;
};
const Qt = /* @__PURE__ */ me(Xt);
function $() {
  return $ = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var t in n)
        Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
    }
    return e;
  }, $.apply(this, arguments);
}
function We(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, $e(e, r);
}
function $e(e, r) {
  return $e = Object.setPrototypeOf || function(n, t) {
    return n.__proto__ = t, n;
  }, $e(e, r);
}
function nt(e, r) {
  if (e == null)
    return {};
  var n, t, i = {}, o = Object.keys(e);
  for (t = 0; t < o.length; t++)
    r.indexOf(n = o[t]) >= 0 || (i[n] = e[n]);
  return i;
}
var v = { BASE: "base", BODY: "body", HEAD: "head", HTML: "html", LINK: "link", META: "meta", NOSCRIPT: "noscript", SCRIPT: "script", STYLE: "style", TITLE: "title", FRAGMENT: "Symbol(react.fragment)" }, er = { rel: ["amphtml", "canonical", "alternate"] }, tr = { type: ["application/ld+json"] }, rr = { charset: "", name: ["robots", "description"], property: ["og:type", "og:title", "og:url", "og:image", "og:image:alt", "og:description", "twitter:url", "twitter:title", "twitter:description", "twitter:image", "twitter:image:alt", "twitter:card", "twitter:site"] }, ot = Object.keys(v).map(function(e) {
  return v[e];
}), pe = { accesskey: "accessKey", charset: "charSet", class: "className", contenteditable: "contentEditable", contextmenu: "contextMenu", "http-equiv": "httpEquiv", itemprop: "itemProp", tabindex: "tabIndex" }, nr = Object.keys(pe).reduce(function(e, r) {
  return e[pe[r]] = r, e;
}, {}), Q = function(e, r) {
  for (var n = e.length - 1; n >= 0; n -= 1) {
    var t = e[n];
    if (Object.prototype.hasOwnProperty.call(t, r))
      return t[r];
  }
  return null;
}, or = function(e) {
  var r = Q(e, v.TITLE), n = Q(e, "titleTemplate");
  if (Array.isArray(r) && (r = r.join("")), n && r)
    return n.replace(/%s/g, function() {
      return r;
    });
  var t = Q(e, "defaultTitle");
  return r || t || void 0;
}, ir = function(e) {
  return Q(e, "onChangeClientState") || function() {
  };
}, Ie = function(e, r) {
  return r.filter(function(n) {
    return n[e] !== void 0;
  }).map(function(n) {
    return n[e];
  }).reduce(function(n, t) {
    return $({}, n, t);
  }, {});
}, ar = function(e, r) {
  return r.filter(function(n) {
    return n[v.BASE] !== void 0;
  }).map(function(n) {
    return n[v.BASE];
  }).reverse().reduce(function(n, t) {
    if (!n.length)
      for (var i = Object.keys(t), o = 0; o < i.length; o += 1) {
        var s = i[o].toLowerCase();
        if (e.indexOf(s) !== -1 && t[s])
          return n.concat(t);
      }
    return n;
  }, []);
}, ee = function(e, r, n) {
  var t = {};
  return n.filter(function(i) {
    return !!Array.isArray(i[e]) || (i[e] !== void 0 && console && typeof console.warn == "function" && console.warn("Helmet: " + e + ' should be of type "Array". Instead found type "' + typeof i[e] + '"'), !1);
  }).map(function(i) {
    return i[e];
  }).reverse().reduce(function(i, o) {
    var s = {};
    o.filter(function(y) {
      for (var m, O = Object.keys(y), _ = 0; _ < O.length; _ += 1) {
        var T = O[_], k = T.toLowerCase();
        r.indexOf(k) === -1 || m === "rel" && y[m].toLowerCase() === "canonical" || k === "rel" && y[k].toLowerCase() === "stylesheet" || (m = k), r.indexOf(T) === -1 || T !== "innerHTML" && T !== "cssText" && T !== "itemprop" || (m = T);
      }
      if (!m || !y[m])
        return !1;
      var D = y[m].toLowerCase();
      return t[m] || (t[m] = {}), s[m] || (s[m] = {}), !t[m][D] && (s[m][D] = !0, !0);
    }).reverse().forEach(function(y) {
      return i.push(y);
    });
    for (var a = Object.keys(s), u = 0; u < a.length; u += 1) {
      var p = a[u], h = $({}, t[p], s[p]);
      t[p] = h;
    }
    return i;
  }, []).reverse();
}, sr = function(e, r) {
  if (Array.isArray(e) && e.length) {
    for (var n = 0; n < e.length; n += 1)
      if (e[n][r])
        return !0;
  }
  return !1;
}, dt = function(e) {
  return Array.isArray(e) ? e.join("") : e;
}, _e = function(e, r) {
  return Array.isArray(e) ? e.reduce(function(n, t) {
    return function(i, o) {
      for (var s = Object.keys(i), a = 0; a < s.length; a += 1)
        if (o[s[a]] && o[s[a]].includes(i[s[a]]))
          return !0;
      return !1;
    }(t, r) ? n.priority.push(t) : n.default.push(t), n;
  }, { priority: [], default: [] }) : { default: e };
}, it = function(e, r) {
  var n;
  return $({}, e, ((n = {})[r] = void 0, n));
}, cr = [v.NOSCRIPT, v.SCRIPT, v.STYLE], Le = function(e, r) {
  return r === void 0 && (r = !0), r === !1 ? String(e) : String(e).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
}, at = function(e) {
  return Object.keys(e).reduce(function(r, n) {
    var t = e[n] !== void 0 ? n + '="' + e[n] + '"' : "" + n;
    return r ? r + " " + t : t;
  }, "");
}, st = function(e, r) {
  return r === void 0 && (r = {}), Object.keys(e).reduce(function(n, t) {
    return n[pe[t] || t] = e[t], n;
  }, r);
}, le = function(e, r) {
  return r.map(function(n, t) {
    var i, o = ((i = { key: t })["data-rh"] = !0, i);
    return Object.keys(n).forEach(function(s) {
      var a = pe[s] || s;
      a === "innerHTML" || a === "cssText" ? o.dangerouslySetInnerHTML = { __html: n.innerHTML || n.cssText } : o[a] = n[s];
    }), Z.createElement(e, o);
  });
}, Y = function(e, r, n) {
  switch (e) {
    case v.TITLE:
      return { toComponent: function() {
        return i = r.titleAttributes, (o = { key: t = r.title })["data-rh"] = !0, s = st(i, o), [Z.createElement(v.TITLE, s, t)];
        var t, i, o, s;
      }, toString: function() {
        return function(t, i, o, s) {
          var a = at(o), u = dt(i);
          return a ? "<" + t + ' data-rh="true" ' + a + ">" + Le(u, s) + "</" + t + ">" : "<" + t + ' data-rh="true">' + Le(u, s) + "</" + t + ">";
        }(e, r.title, r.titleAttributes, n);
      } };
    case "bodyAttributes":
    case "htmlAttributes":
      return { toComponent: function() {
        return st(r);
      }, toString: function() {
        return at(r);
      } };
    default:
      return { toComponent: function() {
        return le(e, r);
      }, toString: function() {
        return function(t, i, o) {
          return i.reduce(function(s, a) {
            var u = Object.keys(a).filter(function(y) {
              return !(y === "innerHTML" || y === "cssText");
            }).reduce(function(y, m) {
              var O = a[m] === void 0 ? m : m + '="' + Le(a[m], o) + '"';
              return y ? y + " " + O : O;
            }, ""), p = a.innerHTML || a.cssText || "", h = cr.indexOf(t) === -1;
            return s + "<" + t + ' data-rh="true" ' + u + (h ? "/>" : ">" + p + "</" + t + ">");
          }, "");
        }(e, r, n);
      } };
  }
}, De = function(e) {
  var r = e.baseTag, n = e.bodyAttributes, t = e.encode, i = e.htmlAttributes, o = e.noscriptTags, s = e.styleTags, a = e.title, u = a === void 0 ? "" : a, p = e.titleAttributes, h = e.linkTags, y = e.metaTags, m = e.scriptTags, O = { toComponent: function() {
  }, toString: function() {
    return "";
  } };
  if (e.prioritizeSeoTags) {
    var _ = function(T) {
      var k = T.linkTags, D = T.scriptTags, B = T.encode, N = _e(T.metaTags, rr), j = _e(k, er), l = _e(D, tr);
      return { priorityMethods: { toComponent: function() {
        return [].concat(le(v.META, N.priority), le(v.LINK, j.priority), le(v.SCRIPT, l.priority));
      }, toString: function() {
        return Y(v.META, N.priority, B) + " " + Y(v.LINK, j.priority, B) + " " + Y(v.SCRIPT, l.priority, B);
      } }, metaTags: N.default, linkTags: j.default, scriptTags: l.default };
    }(e);
    O = _.priorityMethods, h = _.linkTags, y = _.metaTags, m = _.scriptTags;
  }
  return { priority: O, base: Y(v.BASE, r, t), bodyAttributes: Y("bodyAttributes", n, t), htmlAttributes: Y("htmlAttributes", i, t), link: Y(v.LINK, h, t), meta: Y(v.META, y, t), noscript: Y(v.NOSCRIPT, o, t), script: Y(v.SCRIPT, m, t), style: Y(v.STYLE, s, t), title: Y(v.TITLE, { title: u, titleAttributes: p }, t) };
}, se = [], Fe = function(e, r) {
  var n = this;
  r === void 0 && (r = typeof document < "u"), this.instances = [], this.value = { setHelmet: function(t) {
    n.context.helmet = t;
  }, helmetInstances: { get: function() {
    return n.canUseDOM ? se : n.instances;
  }, add: function(t) {
    (n.canUseDOM ? se : n.instances).push(t);
  }, remove: function(t) {
    var i = (n.canUseDOM ? se : n.instances).indexOf(t);
    (n.canUseDOM ? se : n.instances).splice(i, 1);
  } } }, this.context = e, this.canUseDOM = r, r || (e.helmet = De({ baseTag: [], bodyAttributes: {}, encodeSpecialCharacters: !0, htmlAttributes: {}, linkTags: [], metaTags: [], noscriptTags: [], scriptTags: [], styleTags: [], title: "", titleAttributes: {} }));
}, yt = Z.createContext({}), ur = S.shape({ setHelmet: S.func, helmetInstances: S.shape({ get: S.func, add: S.func, remove: S.func }) }), lr = typeof document < "u", re = /* @__PURE__ */ function(e) {
  function r(n) {
    var t;
    return (t = e.call(this, n) || this).helmetData = new Fe(t.props.context, r.canUseDOM), t;
  }
  return We(r, e), r.prototype.render = function() {
    return Z.createElement(yt.Provider, { value: this.helmetData.value }, this.props.children);
  }, r;
}(Ye);
re.canUseDOM = lr, re.propTypes = { context: S.shape({ helmet: S.shape() }), children: S.node.isRequired }, re.defaultProps = { context: {} }, re.displayName = "HelmetProvider";
var X = function(e, r) {
  var n, t = document.head || document.querySelector(v.HEAD), i = t.querySelectorAll(e + "[data-rh]"), o = [].slice.call(i), s = [];
  return r && r.length && r.forEach(function(a) {
    var u = document.createElement(e);
    for (var p in a)
      Object.prototype.hasOwnProperty.call(a, p) && (p === "innerHTML" ? u.innerHTML = a.innerHTML : p === "cssText" ? u.styleSheet ? u.styleSheet.cssText = a.cssText : u.appendChild(document.createTextNode(a.cssText)) : u.setAttribute(p, a[p] === void 0 ? "" : a[p]));
    u.setAttribute("data-rh", "true"), o.some(function(h, y) {
      return n = y, u.isEqualNode(h);
    }) ? o.splice(n, 1) : s.push(u);
  }), o.forEach(function(a) {
    return a.parentNode.removeChild(a);
  }), s.forEach(function(a) {
    return t.appendChild(a);
  }), { oldTags: o, newTags: s };
}, ke = function(e, r) {
  var n = document.getElementsByTagName(e)[0];
  if (n) {
    for (var t = n.getAttribute("data-rh"), i = t ? t.split(",") : [], o = [].concat(i), s = Object.keys(r), a = 0; a < s.length; a += 1) {
      var u = s[a], p = r[u] || "";
      n.getAttribute(u) !== p && n.setAttribute(u, p), i.indexOf(u) === -1 && i.push(u);
      var h = o.indexOf(u);
      h !== -1 && o.splice(h, 1);
    }
    for (var y = o.length - 1; y >= 0; y -= 1)
      n.removeAttribute(o[y]);
    i.length === o.length ? n.removeAttribute("data-rh") : n.getAttribute("data-rh") !== s.join(",") && n.setAttribute("data-rh", s.join(","));
  }
}, ct = function(e, r) {
  var n = e.baseTag, t = e.htmlAttributes, i = e.linkTags, o = e.metaTags, s = e.noscriptTags, a = e.onChangeClientState, u = e.scriptTags, p = e.styleTags, h = e.title, y = e.titleAttributes;
  ke(v.BODY, e.bodyAttributes), ke(v.HTML, t), function(T, k) {
    T !== void 0 && document.title !== T && (document.title = dt(T)), ke(v.TITLE, k);
  }(h, y);
  var m = { baseTag: X(v.BASE, n), linkTags: X(v.LINK, i), metaTags: X(v.META, o), noscriptTags: X(v.NOSCRIPT, s), scriptTags: X(v.SCRIPT, u), styleTags: X(v.STYLE, p) }, O = {}, _ = {};
  Object.keys(m).forEach(function(T) {
    var k = m[T], D = k.newTags, B = k.oldTags;
    D.length && (O[T] = D), B.length && (_[T] = m[T].oldTags);
  }), r && r(), a(e, O, _);
}, te = null, de = /* @__PURE__ */ function(e) {
  function r() {
    for (var t, i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return (t = e.call.apply(e, [this].concat(o)) || this).rendered = !1, t;
  }
  We(r, e);
  var n = r.prototype;
  return n.shouldComponentUpdate = function(t) {
    return !Qt(t, this.props);
  }, n.componentDidUpdate = function() {
    this.emitChange();
  }, n.componentWillUnmount = function() {
    this.props.context.helmetInstances.remove(this), this.emitChange();
  }, n.emitChange = function() {
    var t, i, o = this.props.context, s = o.setHelmet, a = null, u = (t = o.helmetInstances.get().map(function(p) {
      var h = $({}, p.props);
      return delete h.context, h;
    }), { baseTag: ar(["href"], t), bodyAttributes: Ie("bodyAttributes", t), defer: Q(t, "defer"), encode: Q(t, "encodeSpecialCharacters"), htmlAttributes: Ie("htmlAttributes", t), linkTags: ee(v.LINK, ["rel", "href"], t), metaTags: ee(v.META, ["name", "charset", "http-equiv", "property", "itemprop"], t), noscriptTags: ee(v.NOSCRIPT, ["innerHTML"], t), onChangeClientState: ir(t), scriptTags: ee(v.SCRIPT, ["src", "innerHTML"], t), styleTags: ee(v.STYLE, ["cssText"], t), title: or(t), titleAttributes: Ie("titleAttributes", t), prioritizeSeoTags: sr(t, "prioritizeSeoTags") });
    re.canUseDOM ? (i = u, te && cancelAnimationFrame(te), i.defer ? te = requestAnimationFrame(function() {
      ct(i, function() {
        te = null;
      });
    }) : (ct(i), te = null)) : De && (a = De(u)), s(a);
  }, n.init = function() {
    this.rendered || (this.rendered = !0, this.props.context.helmetInstances.add(this), this.emitChange());
  }, n.render = function() {
    return this.init(), null;
  }, r;
}(Ye);
de.propTypes = { context: ur.isRequired }, de.displayName = "HelmetDispatcher";
var fr = ["children"], pr = ["children"], fe = /* @__PURE__ */ function(e) {
  function r() {
    return e.apply(this, arguments) || this;
  }
  We(r, e);
  var n = r.prototype;
  return n.shouldComponentUpdate = function(t) {
    return !Kt(it(this.props, "helmetData"), it(t, "helmetData"));
  }, n.mapNestedChildrenToProps = function(t, i) {
    if (!i)
      return null;
    switch (t.type) {
      case v.SCRIPT:
      case v.NOSCRIPT:
        return { innerHTML: i };
      case v.STYLE:
        return { cssText: i };
      default:
        throw new Error("<" + t.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
    }
  }, n.flattenArrayTypeChildren = function(t) {
    var i, o = t.child, s = t.arrayTypeChildren;
    return $({}, s, ((i = {})[o.type] = [].concat(s[o.type] || [], [$({}, t.newChildProps, this.mapNestedChildrenToProps(o, t.nestedChildren))]), i));
  }, n.mapObjectTypeChildren = function(t) {
    var i, o, s = t.child, a = t.newProps, u = t.newChildProps, p = t.nestedChildren;
    switch (s.type) {
      case v.TITLE:
        return $({}, a, ((i = {})[s.type] = p, i.titleAttributes = $({}, u), i));
      case v.BODY:
        return $({}, a, { bodyAttributes: $({}, u) });
      case v.HTML:
        return $({}, a, { htmlAttributes: $({}, u) });
      default:
        return $({}, a, ((o = {})[s.type] = $({}, u), o));
    }
  }, n.mapArrayTypeChildrenToProps = function(t, i) {
    var o = $({}, i);
    return Object.keys(t).forEach(function(s) {
      var a;
      o = $({}, o, ((a = {})[s] = t[s], a));
    }), o;
  }, n.warnOnInvalidChildren = function(t, i) {
    return rt(ot.some(function(o) {
      return t.type === o;
    }), typeof t.type == "function" ? "You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information." : "Only elements types " + ot.join(", ") + " are allowed. Helmet does not support rendering <" + t.type + "> elements. Refer to our API for more information."), rt(!i || typeof i == "string" || Array.isArray(i) && !i.some(function(o) {
      return typeof o != "string";
    }), "Helmet expects a string as a child of <" + t.type + ">. Did you forget to wrap your children in braces? ( <" + t.type + ">{``}</" + t.type + "> ) Refer to our API for more information."), !0;
  }, n.mapChildrenToProps = function(t, i) {
    var o = this, s = {};
    return Z.Children.forEach(t, function(a) {
      if (a && a.props) {
        var u = a.props, p = u.children, h = nt(u, fr), y = Object.keys(h).reduce(function(O, _) {
          return O[nr[_] || _] = h[_], O;
        }, {}), m = a.type;
        switch (typeof m == "symbol" ? m = m.toString() : o.warnOnInvalidChildren(a, p), m) {
          case v.FRAGMENT:
            i = o.mapChildrenToProps(p, i);
            break;
          case v.LINK:
          case v.META:
          case v.NOSCRIPT:
          case v.SCRIPT:
          case v.STYLE:
            s = o.flattenArrayTypeChildren({ child: a, arrayTypeChildren: s, newChildProps: y, nestedChildren: p });
            break;
          default:
            i = o.mapObjectTypeChildren({ child: a, newProps: i, newChildProps: y, nestedChildren: p });
        }
      }
    }), this.mapArrayTypeChildrenToProps(s, i);
  }, n.render = function() {
    var t = this.props, i = t.children, o = nt(t, pr), s = $({}, o), a = o.helmetData;
    return i && (s = this.mapChildrenToProps(i, s)), !a || a instanceof Fe || (a = new Fe(a.context, a.instances)), a ? /* @__PURE__ */ Z.createElement(de, $({}, s, { context: a.value, helmetData: void 0 })) : /* @__PURE__ */ Z.createElement(yt.Consumer, null, function(u) {
      return Z.createElement(de, $({}, s, { context: u }));
    });
  }, r;
}(Ye);
fe.propTypes = { base: S.object, bodyAttributes: S.object, children: S.oneOfType([S.arrayOf(S.node), S.node]), defaultTitle: S.string, defer: S.bool, encodeSpecialCharacters: S.bool, htmlAttributes: S.object, link: S.arrayOf(S.object), meta: S.arrayOf(S.object), noscript: S.arrayOf(S.object), onChangeClientState: S.func, script: S.arrayOf(S.object), style: S.arrayOf(S.object), title: S.string, titleAttributes: S.object, titleTemplate: S.string, prioritizeSeoTags: S.bool, helmetData: S.object }, fe.defaultProps = { defer: !0, encodeSpecialCharacters: !0, prioritizeSeoTags: !1 }, fe.displayName = "Helmet";
const _r = ({
  pageTitle: e,
  siteTitle: r = ""
}) => /* @__PURE__ */ g(
  fe,
  {
    children: /* @__PURE__ */ H("title", { children: [
      e ? `${e} | ` : "",
      r
    ] })
  }
), dr = ({ children: e, ...r }) => /* @__PURE__ */ g(St, { ...r, children: /* @__PURE__ */ g(Ot, { children: e }) }), yr = ({ children: e }) => /* @__PURE__ */ g("h3", { className: "titleTxt", children: e }), Lr = ({
  title: e,
  actionsStyle: r = "right",
  actions: n,
  children: t,
  ...i
}) => /* @__PURE__ */ g(dr, { ...i, children: /* @__PURE__ */ H(ht, { children: [
  /* @__PURE__ */ H("div", { className: "mb-6", children: [
    /* @__PURE__ */ g(yr, { children: e }),
    t
  ] }),
  /* @__PURE__ */ g(
    "div",
    {
      className: `flex gap-2 ${r === "right" ? "justify-end" : "flex-col"} `,
      children: n.map(
        ({ label: o, onClick: s, disabled: a = !1, variant: u = "text" }, p) => /* @__PURE__ */ g(
          qe,
          {
            onClick: s,
            variant: r === "right" ? "text" : u,
            disabled: a,
            children: o
          },
          `${o}-${p}`
        )
      )
    }
  )
] }) }), kr = ({
  children: e,
  className: r = ""
}) => e ? /* @__PURE__ */ g("p", { className: `text-pi-utility-red ${r}`, children: e }) : null, hr = [
  '"FS Elliot Pro"',
  "Roboto",
  "ui-sans-serif",
  "system-ui",
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  '"Helvetica Neue"',
  "Arial",
  '"Noto Sans"',
  "sans-serif",
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
  '"Noto Color Emoji"'
], je = {
  "dark-prussian-blue": "#002855",
  "prussian-blue": "#003865",
  "navy-blue": "#004c97",
  "principal-blue": "#0076cf",
  "true-blue": "#0091da",
  "dark-maya-blue": "#62b5e5",
  "maya-blue": "#94d8fa",
  "sky-blue-4": "#bbe6fc",
  "sky-blue-3": "#d2f1fd",
  "sky-blue-2": "#e3f5fd",
  "sky-blue-1": "#F0FBFE",
  "dark-ocean-cyan": "#315470",
  "ocean-cyan": "#007FA3",
  cyan: "#00c4d9",
  "bright-cyan": "#55FFF5",
  chartreuse: "#DCF94D",
  "gray-1": "#333333",
  "gray-2": "#616267",
  "gray-3": "#9D9EA4",
  "gray-4": "#C5C6C5",
  "gray-5": "#E8E8E8",
  "gray-6": "#F6F6F8",
  "gray-7": "#FBFBFB",
  "utility-red": "#cc0000",
  "utility-red-light": "#ff3333",
  "utility-orange": "#f76800",
  "utility-orange-light": "#ff9d5c",
  "utility-green": "#00a29b",
  "utility-green-light": "#00d6cb",
  "utility-blue": "#0061A0",
  "utility-blue-light": "#059bff",
  "data-orange": "#ffc82e",
  "data-purple": "#9e8BFF"
}, ce = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1136px"
}, jr = (e) => ({
  typography: {
    fontFamily: hr.join(",")
  },
  palette: {
    primary: {
      // light: '#3391d8',
      main: je["principal-blue"],
      // dark: '#005290',
      contrastText: "#fff"
    },
    secondary: {
      // light: '#81c3ea',
      main: je["dark-maya-blue"],
      // dark: '#447ea0',
      contrastText: je["gray-2"]
    }
    // text: {
    //   disabled: '#f00',
    // },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: parseInt(ce.sm, 10),
      md: parseInt(ce.md, 10),
      lg: parseInt(ce.lg, 10),
      xl: parseInt(ce.xl, 10)
    }
  },
  components: {
    MuiPopover: {
      defaultProps: {
        container: e
      }
    },
    MuiPopper: {
      defaultProps: {
        container: e
      }
    },
    MuiModal: {
      defaultProps: {
        container: e
      }
    },
    MuiSwipeableDrawer: {
      defaultProps: {
        container: e
      }
    }
  }
}), Nr = () => {
  const [e, r] = He(!1);
  return { open: e, modalOpen: () => r(!0), modalClose: () => r(!1) };
}, $r = () => {
  const [e, r] = He(!1);
  return { showPassword: e, toggleHideShow: () => r(!e) };
}, Dr = () => He(void 0), mr = (e) => /* @__PURE__ */ F.createElement("svg", { width: 16, height: 17.5, "view-box": "0 -1.5 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ F.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.00008 14.6663C8.00008 14.6663 13.3334 11.9997 13.3334 7.99967V2.66634L8.00008 1.33301L2.66675 2.66634V7.99967C2.66675 11.9997 8.00008 14.6663 8.00008 14.6663Z", stroke: "#ddf75b", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), vr = "https://www.principal.com.my/", Fr = ({
  urlPrefix: e = vr,
  links: r,
  text: { regulatedByScm: n }
}) => /* @__PURE__ */ H("footer", { className: "footer bg-pi-dark-prussian-blue text-white p-6 min-h-[202px] sm:p-10", children: [
  /* @__PURE__ */ g("div", { className: "flex flex-col flex-wrap gap-y-4 mb-4 sm:flex-row sm:gap-x-10 sm:mb-10 max-w-[1056px] mx-auto", children: r.map(({ hrefPart: t, label: i }) => /* @__PURE__ */ g(
    "a",
    {
      className: "text-white hover:text-pi-sky-blue-4 text-sm leading-[22px]",
      href: `${e}${t}`,
      target: "_blank",
      rel: "noreferrer",
      children: i
    },
    i
  )) }),
  /* @__PURE__ */ H("div", { className: "text-[#ddf75b] text-xs leading-5 flex gap-2 max-w-[1056px] mx-auto", children: [
    /* @__PURE__ */ g(mr, {}),
    n
  ] })
] }), qr = ({
  flipColor: e = !1,
  className: r = "",
  children: n
}) => /* @__PURE__ */ g(
  "main",
  {
    className: `main-body min-h-[calc(100svh-333.889px)] sm:min-h-[calc(100svh-202px)] px-4 py-6 ${e ? "bg-pi-prussian-blue sm:bg-transparent" : ""} ${r}`,
    children: /* @__PURE__ */ g("div", { className: "max-w-screen-xl mx-auto grid grid-cols-12 gap-6", children: n })
  }
), Yr = (e) => e.replace(/\*/g, "•");
export {
  Lr as ActionModal,
  dr as BasicModal,
  yr as BasicModalTitle,
  xr as ButtonWithLoading,
  Er as CSLink,
  At as CS_URL,
  wr as CheckboxGroupComp,
  Sr as CurrencyTextField,
  vr as FOOTER_URL_PREFIX,
  Fr as Footer,
  Be as FormErrorMessage,
  Or as FormLabel,
  _r as HelmetSiteTitle,
  qr as MainBody,
  Ar as PasswordTextField,
  Pr as PropmoteCodeInput,
  Lt as Radio,
  Rr as RadioGroupComp,
  Pt as Required,
  kr as ResponseError,
  Mr as SelectBoxComp,
  Ir as TelTextField,
  Yr as convertMask,
  jr as muiTheme,
  Nr as useModal,
  $r as usePasswordText,
  Dr as useResponseError
};
